// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"bf038f47","683":"bf038f47","3184":"bf038f47","3328":"bf038f47","4380":"fcda2223"}[chunkId] + ".chunk.css";
};